import { render, staticRenderFns } from "./side-drawer-dialog.vue?vue&type=template&id=242009fa"
import script from "./side-drawer-dialog.vue?vue&type=script&lang=js"
export * from "./side-drawer-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports